var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCover = function SvgCover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M364.52 199.26h-30.57l74.57-74.57-21.21-21.21-74.57 74.57v-30.57h-30v81.78h81.78z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M448 34H34v444h444V34Zm0 414H64V64h384Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m312.74 333.95 74.57 74.57 21.21-21.21-74.57-74.57h30.57v-30h-81.78v81.78h30zM199.26 333.95v30.57h30v-81.78h-81.78v30h30.57l-74.57 74.57 21.21 21.21zM147.48 199.26v30h81.78v-81.78h-30v30.57l-74.57-74.57-21.21 21.21 74.57 74.57z"
  })));
};
export default SvgCover;